import axios from "axios"
const baseUrl = process.env.REACT_APP_API_BASEURL

/**
* @function getOverallDimensionIndustryData
* @param {  authToken, id, industry }
* @description This function is used to get over all user dimension data list based on industry
*/
export const getOverallDimensionIndustryData = async ({ authToken, id, industry, userId }) => {
    const result = axios.get(`${baseUrl}users/associcated/companies/usersLevel?dimension=${id}&userId=${userId}&industry=${industry}`, {
        headers: {
            Authorization: `Bearer ${authToken}`,
        }
    })
    return result;
};